module.exports = {
    atlasParser: require('./atlasParser'),
    Loader: require('./Loader'),
    syncImageLoaderAdapter: require('./syncImageLoaderAdapter'),
    imageLoaderAdapter: require('./imageLoaderAdapter')
};
